
import TwigMessages from '@marketplace/components/TwigMessages.vue'

export default {
    name: 'EmptyLayout',

    components: {
        TwigMessages,
    },

    props: {
        disableModalWrapper: {
            type: Boolean,
            default: false,
        },
    },
}
